<template>
    <div>
        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="col">
                        <div class="card-header-title">
                            <span class="mdi mdi-format-letter-matches mr-2 text-muted" style="font-size: 1.2em;"></span> 
                            Report Field Templates
                        </div>
                    </div>
                    <div class="col">
                        <button class="btn btn-primary btn-sm float-right" @click="showCreateFieldModal">
                            <span class="mdi mdi-plus"></span> Create New Field
                        </button>
                    </div>
                </div>
            </div>
            <div class="card-body">
                <b-table ref="fieldTemplateTable"
                    hover small striped borderless
                    :items="fieldTemplates"
                    :fields="fieldTemplateFields">
                    <template v-slot:cell(_actions)="data">
                        <router-link class="btn btn-primary btn-sm float-right mr-1" 
                                     :to="{ name: routes.Templates.FieldTemplateEdit, params: { fieldId: data.item.field_id } }">
                            <span class="mdi mdi-file-document-edit-outline"></span>  Edit
                        </router-link>
                    </template>
                </b-table>

                <LoadingIndicator v-if="viewState == 'Busy'" />
                <ErrorMessage v-if="viewState == 'Error'" />
            </div>
        </div>

        <!-- Add new field modal -->
        <b-modal id="modal-create-field" 
            title="Create Field Template"
            ok-title="Save"
            :ok-disabled="!newFieldTemplateIsValid"
            @ok="onCreateFieldTemplateOK">
            <div v-if="newFieldTemplate">                
                <div class="form-group">
                    <label>Input Type <span class="text-danger">*</span></label>
                    <select class="form-control" v-model="newFieldTemplate.input_type">
                        <option value="text">Text</option>
                        <option value="date">Date</option>
                        <option value="bool">Switch (Yes/No)</option>
                        <option value="select">Picker Wheel</option>
                        <option value="multi_select">Multi-Select</option>
                    </select>
                </div>

                <div class="form-group">
                    <label>Label <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" v-model="newFieldTemplate.label" required>
                </div>
                <hr>                

                <div class="form-group">
                    <label>Unique Identifier <span class="text-danger">*</span></label>
                    <input type="text" class="form-control" :class="newFieldTemplateNameIsValid ? '' : 'invalid-field'" v-model="newFieldTemplate.name">
                </div>

                <div class="alert alert-info">
                    <div class="row">
                        <div class="col-1" style="line-height: 50px;">
                            <span class="mdi mdi-information-outline" style="font-size: 1.6em; margin-left: -6px;"></span>
                        </div>
                        <div class="col-11">
                            <p>The identifier for the new field should be unique and must not contain spaces or special characters.</p>
                            <p class="mb-1"><strong>Note: </strong> Identifier cannot be changed after the field has been created</p>
                        </div>
                    </div>
                </div>
            </div>
        </b-modal>
        <!-- /Add new field modal -->

    </div>
</template>

<script>
    import FieldTemplateService from '../../../services/templates/fieldTemplateService'
    import { RouteNames } from '../../../utils/constants'

    export default {
        data() {
            return {
                viewState: 'Idle',
                error: null,
                routes: RouteNames,
                newFieldTemplate: null,
                fieldTemplates: null,
                fieldTemplateFields: [
                    { key: 'name', label: 'Name', sortable: true },
                    { key: 'category', label: 'category', sortable: true },
                    {
                        key: 'input_type',
                        label: 'Input Type',
                        sortable: true,
                        formatter: this.formatFriendlyInputType
                    },
                    //{ key: '_is_comp', label: 'Is Comp' },
                    { key: '_actions', label: ' ' }
                ]
            }
        },
        computed: {
            newFieldTemplateIsValid() {
                return this.newFieldTemplate && 
                       this.newFieldTemplateNameIsValid &&
                       this.newFieldTemplate.name && 
                       this.newFieldTemplate.label && 
                       this.newFieldTemplate.input_type
            },
            newFieldTemplateNameIsValid() {
                if (!this.newFieldTemplate.name) {
                    return true
                }
                else {
                    let matchingFields = this.fieldTemplates.filter(t => {
                        return t.name == this.newFieldTemplate.name
                    })
                    
                    return this.newFieldTemplate.name &&
                           this.newFieldTemplate.name.indexOf(' ') == -1 &&
                           this.newFieldTemplate.name.search(/[!\-@#$%^&*(),.?":{}|<>]/g) == -1 &&
                           matchingFields.length == 0
                }                
            }
        },
        async mounted() {
            this.viewState = 'Busy'
            try {
                this.fieldTemplates = await FieldTemplateService.getReportFieldTemplates()
                this.viewState = 'Idle'
            } catch (err) {                
                this.viewState = 'Error'
                this.error = err
                console.error(err)
            }
        },
        methods: {
            formatFriendlyInputType(val) {
                let output = ''
                switch (val) {
                    case 'date':
                        output = 'Datepicker'
                        break
                    case 'select':
                        output = 'Wheel'
                        break
                    case 'text':
                        output = 'Text'
                        break
                    case 'bool':
                        output = 'Switch (Yes/No)'
                        break
                    case 'multi_select':
                        output = 'MultiSelect'
                        break
                    default:
                        output = val
                        break
                }

                return output
            },
            showCreateFieldModal() {
                this.newFieldTemplate = { }
                this.$bvModal.show('modal-create-field')
            },            
            async onCreateFieldTemplateOK(evt) {
                evt.preventDefault()
                if (this.newFieldTemplateIsValid) {
                    try {
                        let createResult = await FieldTemplateService.createReportFieldTemplate(this.newFieldTemplate)
                        this.$router.push({
                            name: RouteNames.Templates.FieldTemplateEdit,
                            params: {
                                fieldId: createResult.field_id,
                                fieldTemplateProp: createResult,
                                isCreateResult: true
                            }
                        })
                    } catch (err) {
                        console.error(err)
                        this.$bvToast.toast('Sorry, something went wrong and we couldn\'t create the template', {
                            title: 'Error',
                            variant: 'danger',
                            solid: true,
                            appendToast: true,
                            autoHideDelay: 3000
                        })
                    }
                }
            }
        }
    }
</script>

<style lang="scss">
    .table-sm th, .table-sm td {
        line-height: 32px;
        outline: none;
    }

    .invalid-field {
        border: 1px solid red !important;
    }
</style>